import React from "react";

const MSMEComplianceRules = () => {
  return (
    <div className="bg-black min-h-screen p-4 text-white">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4">MSME Compliance Rules</h1>
      
      <p className="mb-4 text-gray-300">
        This page lists the latest compliance rules applicable for MSMEs across various sectors and states. Use this page to stay updated on regulatory changes.
      </p>

      {/* Dummy list of rules */}
      <div className="space-y-3">
        {[
          "GST Filing Rules – Updated for FY 2026",
          "EPF & ESI Contribution Changes",
          "Labour Codes Compliance – State-specific updates",
          "FSSAI License Renewal Guidelines",
          "Udyam Registration Amendments"
        ].map((rule, index) => (
          <div
            key={index}
            className="bg-gray-900 p-3 rounded-md shadow hover:bg-gray-800 transition cursor-pointer"
          >
            {rule}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MSMEComplianceRules;